enum BillingType {
  FORECAST = 'FORECAST',
  ACTUALS = 'ACTUALS',
  NON_BILLABLE = 'NON_BILLABLE',
  FIXED_PRICE = 'FIXED_PRICE'
}

export default BillingType;
